<div class="drawer-content-container" [ngClass]="rootClassName">
  @if (hasNotification) {
    <pop-ui-drawer-content-notification [notification]="notification"></pop-ui-drawer-content-notification>
  }

  @if (hasRecommendation) {
    <div class="frame24pxspacer"></div>
    <div class="drawer-content-header">
      <span class="drawer-content--header-title headingboldsmall">
        <span>{{title}}</span>
      </span>
      <span class="drawer-content-header-subtitle labelregularsmall">
        <span>{{subtitle}}</span>
      </span>
    </div>
  }

  @if (isPerformance) {
    @if (isPerformanceStats && !isEmpty('Stats')) {
      <div class="frame24pxspacer"></div>
      <pop-ui-performance-stats [stats]="stats" [(state)]="state"></pop-ui-performance-stats>
    }
    @if (isPerformanceCharts && !isEmpty('Charts')) {
      <div class="drawer-content performance" [ngClass]="{'web':isWeb}">
        <div class="frame24pxspacer"></div>
        <pop-ui-performance-charts [charts]="charts"></pop-ui-performance-charts>
      </div>
    }
  }

  @if (hasLessonList) {
    <div class="drawer-content noscrollbar {{contentClassName}}" [ngClass]="{'web':isWeb}">
      @if (!isLessonCompletion) {
        <pop-ui-lessons-list [(state)]="state"></pop-ui-lessons-list>
      }
      @if (isLessonCompletion && lesson) {
        <pop-ui-lesson-terms [lesson]="lesson"></pop-ui-lesson-terms>
      }
    </div>
  }
</div>
